import { weaponNuggetsColumn } from "../resource/weapon-nuggets-column";
import { NeededColumn } from "./needed-column";

export const weaponNuggetNeededColumn = new NeededColumn(
  "8d8c7ac2-696b-4718-84b1-30e28d3b7a78",
  weaponNuggetsColumn,
  "Red Nug Needed"
)
